export default __webpack_public_path__ + "static/media/icn-profile-active.db3fcaef.svg";